import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from "vue";
import CloudTag from "@/components/CloudTag/index.vue";
export default /*#__PURE__*/ _defineComponent({
    name: 'index',
    props: {
        type: { default: "" }
    },
    setup(__props) {
        const props = __props;
        const typeText = {
            master: "主账号",
            admin: "管理员",
            sub: "子账号"
        };
        const getClass = computed(() => props.type === "master" || props.type === "admin"
            ? "master-style"
            : "sub-style");
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["verify-row", _unref(getClass)])
            }, [
                _createVNode(CloudTag, {
                    class: "master-style",
                    icon: "confirm"
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("span", null, _toDisplayString(typeText[__props.type]), 1)
                    ]),
                    _: 1
                })
            ], 2));
        };
    }
});
